/**
 * THE RESTAURANT THIS DEVICE LAST SIGNED INTO — its name and logo, for the
 * login screen's corner (claude.ai/design "Login").
 *
 * The till is a shared device, and before anyone signs in the app does not
 * know which restaurant it belongs to: every store logs in on the same host.
 * So the brand is remembered at sign-in. Both are the restaurant's public face
 * (the logo is the one on its QR stickers), not credentials. Storage can be
 * blocked (a private window), so every read and write is guarded and the
 * screen falls back to Trioty's own mark.
 */
const KEY = "trioty-restaurant-last-store";

export type RememberedStore = { name: string; logoUrl: string | null };

export function rememberedStore(): RememberedStore | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    // Older builds stored the bare name.
    if (!raw.startsWith("{")) return raw.trim() ? { name: raw.trim(), logoUrl: null } : null;
    const parsed = JSON.parse(raw) as Partial<RememberedStore>;
    if (typeof parsed.name !== "string" || !parsed.name.trim()) return null;
    return {
      name: parsed.name.trim(),
      logoUrl: typeof parsed.logoUrl === "string" && parsed.logoUrl ? parsed.logoUrl : null,
    };
  } catch {
    return null;
  }
}

export function rememberStore(store: { name: string | null | undefined; logoUrl?: string | null }): void {
  try {
    if (!store.name || !store.name.trim()) return;
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ name: store.name.trim(), logoUrl: store.logoUrl ?? null }),
    );
  } catch {
    // Storage blocked: the login screen shows Trioty's mark instead.
  }
}
